import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { fetchValidConfigCode } from "../services/configCodes.service.ts";
import type { ConfigCode as ConfigCodeType } from "../types/ConfigCode.ts";
import { PageContainer, PageTitle } from "../components/Layout.tsx";
import { parseApiError } from "../utils/errorHandler.ts";

const ContentCard = styled.div`
  background: white;
  border-radius: 12px;
  padding: 3rem;
  box-shadow: 0 2px 8px rgba(0, 31, 82, 0.1);
  border-left: 4px solid #64da4c;
  transition: background 0.3s ease, box-shadow 0.3s ease;

  .dark-mode & {
    background: #2a2a3e;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
  }
`;

const CodeBox = styled.div`
  font-family: "Fira Code", monospace;
  font-size: 1.4rem;
  padding: 1rem 1.5rem;
  border-radius: 8px;
  background: #001f52;
  color: #ffffff;
  display: inline-block;
  margin-top: 1rem;
  transition: background 0.3s ease;

  .dark-mode & {
    background: #64da4c;
    color: #001f52;
  }
`;

const SecondaryText = styled.p`
  margin-top: 0.75rem;
  color: #666;
  transition: color 0.3s ease;

  .dark-mode & {
    color: #b0b0b0;
  }
`;

export default function ConfigCode() {
  const [code, setCode] = useState<ConfigCodeType | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const loadCode = () => {
    setLoading(true);
    setError(null);
    fetchValidConfigCode()
      .then(res => {
        setCode(res);
      })
      .catch(err => {
        setError(parseApiError(err));
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    loadCode();
  }, []);

  return (
    <PageContainer>
      <PageTitle>Kode til konfiguration</PageTitle>
      <ContentCard>
        {loading && (
          <p style={{ color: "#666", transition: "color 0.3s ease" }} className="dark-mode-text-secondary">
            Indlæser konfigurationskoder...
          </p>
        )}
        {error && (
          <p style={{ color: "#d32f2f", transition: "color 0.3s ease" }} className="dark-mode-text-error">
            {error}
          </p>
        )}

        {!loading && !error && code && (
          <>
            <p style={{ color: "#666", transition: "color 0.3s ease" }} className="dark-mode-text-secondary">
              Del denne kode med teknikerne, så deres Apps kan forbindes til vores portal.
            </p>
            <p style={{ color: "#666", transition: "color 0.3s ease" }} className="dark-mode-text-secondary">
              Bemærk! Denne kode er kun gyldig indtil midnat.
            </p>
            <CodeBox>{code.configCode}</CodeBox>

          </>
        )}

        {!loading && !error && !code && (
          <SecondaryText>
            Der er endnu ingen konfigurationskoder.
          </SecondaryText>
        )}
      </ContentCard>
    </PageContainer>
  );
}
